import { Application, Extension } from "@verity/proctoring-option/types";
import { useEffect, useState } from "react";
import apiClient from "../../../helpers/api-client";

export default function useFetchProctoringData() {
	const [applications, setApplications] = useState<Application[]>([]);
	const [extensions, setExtensions] = useState<Extension[]>([]);

	useEffect(() => {
		async function fetchApplicationData() {
			const APPLICATION_LIST = await apiClient.verityOptions.getAllApplications();
			setApplications(APPLICATION_LIST);
		}

		async function fetchExtensionData() {
			const EXTENSION_LIST = await apiClient.verityOptions.getAllExtensions();
			setExtensions(EXTENSION_LIST);
		}

		void fetchApplicationData();
		void fetchExtensionData();
	}, []);

	return {
		applications,
		extensions,
	};
}

export type UseFetchProctoringDataReturn = ReturnType<typeof useFetchProctoringData>;
